import { format } from 'date-fns';
import type { FlightActivity } from '../types';
import { tz } from '../utils/timezone';

interface Props {
  flights: FlightActivity[];
}

export function FlightActivityCard({ flights }: Props) {
  return (
    <div className="hud-card h-full">
      <div className="hud-corner-tl" /><div className="hud-corner-tr" /><div className="hud-corner-bl" /><div className="hud-corner-br" />
      <div className="hud-card-header">
        <div className="flex items-center gap-2.5">
          <svg className="w-4 h-4 text-hud-green opacity-80" viewBox="0 0 16 16" fill="none">
            <path d="M2 12L8 3L14 12" stroke="currentColor" strokeWidth="1.2" strokeLinejoin="round"/>
          </svg>
          <span className="hud-card-title">Flight Activity</span>
        </div>
        <span className="hud-card-badge">LAST 50</span>
      </div>
      <div className="hud-card-body">
        <div className="max-h-[420px] overflow-y-auto">
          <table className="w-full border-collapse">
            <thead>
              <tr>
                <th className="font-mono text-[9px] tracking-[2px] uppercase text-[#3a5a6a] text-left pb-1.5 px-2.5 border-b border-[#152030] sticky top-0 bg-card">Time ({tz})</th>
                <th className="font-mono text-[9px] tracking-[2px] uppercase text-[#3a5a6a] text-left pb-1.5 px-2.5 border-b border-[#152030] sticky top-0 bg-card">Device</th>
                <th className="font-mono text-[9px] tracking-[2px] uppercase text-[#3a5a6a] text-left pb-1.5 px-2.5 border-b border-[#152030] sticky top-0 bg-card">Flight</th>
                <th className="font-mono text-[9px] tracking-[2px] uppercase text-[#3a5a6a] text-right pb-1.5 px-2.5 border-b border-[#152030] sticky top-0 bg-card">Alt (m)</th>
                <th className="font-mono text-[9px] tracking-[2px] uppercase text-[#3a5a6a] text-right pb-1.5 px-2.5 border-b border-[#152030] sticky top-0 bg-card">Spd (km/h)</th>
              </tr>
            </thead>
            <tbody>
              {flights.map((flight, idx) => (
                <tr
                  key={`${flight.flightCode}-${flight.timestamp.getTime()}-${idx}`}
                  className="border-b border-[#0d1825] hover:bg-[rgba(0,255,136,0.03)] transition-colors"
                >
                  <td className="font-mono text-xs text-[#5a7a8a] py-2 px-2.5">
                    {format(flight.timestamp, 'HH:mm:ss')}
                  </td>
                  <td className="font-mono text-[10px] text-[#4a6a7a] py-2 px-2.5">
                    {flight.device}
                  </td>
                  <td className="font-mono text-xs font-medium py-2 px-2.5">
                    {flight.flightCode ? (
                      <a
                        href={`https://www.flightradar24.com/data/flights/${flight.flightCode.toLowerCase()}#${flight.flightId}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-hud-green hover:text-white hover:underline transition-colors"
                      >
                        {flight.flightCode}
                      </a>
                    ) : (
                      <span className="text-[#3a5a6a]">{flight.flightId}</span>
                    )}
                  </td>
                  <td className="font-mono text-xs text-hud-cyan text-right py-2 px-2.5">
                    {Math.round(flight.altitude * 0.3048).toLocaleString()}
                  </td>
                  <td className="font-mono text-xs text-hud-amber text-right py-2 px-2.5">
                    {Math.round(flight.speed * 1.852)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {flights.length === 0 && (
            <p className="font-mono text-sm text-[#3a5a6a] text-center py-8">No flights detected yet</p>
          )}
        </div>
      </div>
    </div>
  );
}
